export type ConsentChoice = 'unset' | 'granted' | 'denied'
export type ConsentRegionMode = 'unknown' | 'nz-opt-out' | 'explicit-opt-in'
export type MeasurementConsentBasis = 'explicit-grant' | 'explicit-deny' | 'nz-default' | 'not-permitted'

export function classifyConsentRegion(countryCode: string | null | undefined): Exclude<ConsentRegionMode, 'unknown'> {
  return countryCode?.trim().toUpperCase() === 'NZ' ? 'nz-opt-out' : 'explicit-opt-in'
}

export function effectiveConsent(
  storedChoice: ConsentChoice,
  regionMode: ConsentRegionMode,
): ConsentChoice {
  if (storedChoice !== 'unset') return storedChoice
  return regionMode === 'nz-opt-out' ? 'granted' : 'unset'
}

export function resolveMeasurementConsent(
  storedChoice: ConsentChoice,
  countryCode: string | null | undefined,
): { consent: ConsentChoice; basis: MeasurementConsentBasis } {
  if (storedChoice === 'granted') return { consent: 'granted', basis: 'explicit-grant' }
  if (storedChoice === 'denied') return { consent: 'denied', basis: 'explicit-deny' }
  if (classifyConsentRegion(countryCode) === 'nz-opt-out') {
    return { consent: 'granted', basis: 'nz-default' }
  }
  return { consent: 'unset', basis: 'not-permitted' }
}
